import { kebabCase } from "../../helpers";

export const filterListByKeywordGivenKeyNames = (
  items,
  keyword = "",
  keysToSearch
) => {
  if (!items || !Array.isArray(items) || items.length === 0) return [];

  const formattedKeyword = keyword.trim().toLocaleLowerCase();
  if (!formattedKeyword) return items;

  const keys =
    keysToSearch && Array.isArray(keysToSearch) && keysToSearch.length > 0
      ? keysToSearch
      : null;

  return items.filter((item) => {
    if (!item) return false;
    const searchKeys = keys || Object.keys(item);

    return searchKeys.some((key) => {
      const formattedKey =
        key === `status`
          ? item[key][`type`]
          : `${item[key]}`.toLocaleLowerCase();
      return formattedKey.includes(formattedKeyword);
    });
  });
};

export const getTextOccurrencesOnListByKeyName = (objects, keyName, sort) => {
  if (!objects || !objects.length) return [];

  const occurrencesMap = new Map();
  objects.forEach((obj) => {
    const rawValue = obj[keyName];
    if (!rawValue) return;

    const ocurrenciesCount = (occurrencesMap.get(rawValue) || 0) + 1;
    occurrencesMap.set(rawValue, ocurrenciesCount);
  });

  return Array.from(occurrencesMap, ([raw, count]) => ({
    raw,
    key: kebabCase(raw),
    count,
  })).sort((o1, o2) => (o1.key > o2.key ? 1 : -1));
};

export const addMissingTableFilters = (
  filtersWithData,
  possibleFiltersTexts = []
) => {
  return possibleFiltersTexts.reduce((acc, current) => {
    const isFilterMissing =
      acc.findIndex((filter) => filter.raw === current) === -1;
    if (isFilterMissing) {
      return [
        ...acc,
        {
          raw: current,
          key: kebabCase(current),
          count: 0,
        },
      ].sort((o1, o2) => (o1.key > o2.key ? 1 : -1));
    }

    return acc;
  }, filtersWithData);
};
